import PropTypes from 'prop-types';

/**
 * FactContent component - Displays factual statements as content
 */
const FactContent = ({ item }) => {
	return (
		<div className='fact-content'>
			<div className='fact-text'>{item.content}</div>
		</div>
	);
};

FactContent.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		content: PropTypes.string,
		category: PropTypes.string,
		is_key: PropTypes.bool,
		source: PropTypes.string,
	}).isRequired,
};

export default FactContent;
